export default __webpack_public_path__ + "static/media/whitening-ball.2eb423de.png";